import {default as Video} from "./Video"
import {default as VideoSpecs} from "./VideoSpecs"
import VideoProviderBuilder from "./VideoProviderBuilder";

export const video = new Video(new VideoProviderBuilder())
export const videoSpecs = new VideoSpecs()